import { Box, Divider, Typography } from "@mui/material";
import { AutoAwesome, Layers } from "@mui/icons-material";
import { useTranslationApp } from "../../../../lib/i18next";
import {
  MODAL_IMAGE_EDIT_WORK_MODE_LABEL,
  MODAL_IMAGE_EDIT_GENERATIVE_TITLE,
  MODAL_IMAGE_EDIT_LAYERS_TITLE,
} from "../../../../i18n/keysTranslations";
import { BOX_SHADOW_BUTTON } from "../../../../utils/colors";
import { IMAGE_EDIT_WORK_MODE } from "../layers/layerGeometry";

const ModeCard = ({ selected, icon, title, onClick, disabled = false }) => {
  return (
    <Box
      component="button"
      type="button"
      disabled={disabled}
      aria-disabled={disabled}
      onClick={disabled ? undefined : onClick}
      sx={{
        position: "relative",
        width: "100%",
        minWidth: 0,
        textAlign: "left",
        border: "none",
        bgcolor: selected ? "background.paper" : "transparent",
        borderRadius: 1.5,
        px: 1.25,
        py: 1.25,
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 1,
        boxShadow: selected ? BOX_SHADOW_BUTTON : "none",
        transition: "background-color 0.15s ease, box-shadow 0.15s ease",
      }}
    >
      <Box
        sx={{
          width: 22,
          height: 22,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "text.primary",
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>
      <Typography
        variant="body2"
        sx={{
          fontWeight: 600,
          lineHeight: 1.25,
          color: "text.primary",
          whiteSpace: "nowrap",
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

const WorkModeSelector = ({ selectedValue, onChange, disabled = false }) => {
  const { t } = useTranslationApp();

  return (
    <Box sx={{ flexShrink: 0 }}>
      <Box sx={{ px: 2, pt: 1.5, pb: 1.5 }}>
        <Typography
          variant="caption"
          sx={{
            display: "block",
            fontWeight: 700,
            letterSpacing: 0.6,
            color: "text.secondary",
            mb: 1,
            textTransform: "uppercase",
          }}
        >
          {t(MODAL_IMAGE_EDIT_WORK_MODE_LABEL)}
        </Typography>
        <Box
          role="radiogroup"
          aria-label={t(MODAL_IMAGE_EDIT_WORK_MODE_LABEL)}
          sx={{
            bgcolor: "#f5f5f5",
            borderRadius: 2,
            p: 0.75,
            display: "flex",
            flexDirection: "column",
            gap: 0.75,
          }}
        >
          <ModeCard
            selected={selectedValue === IMAGE_EDIT_WORK_MODE.GENERATIVE}
            icon={<AutoAwesome sx={{ fontSize: 18 }} />}
            title={t(MODAL_IMAGE_EDIT_GENERATIVE_TITLE)}
            disabled={disabled}
            onClick={() => onChange(IMAGE_EDIT_WORK_MODE.GENERATIVE)}
          />
          <ModeCard
            selected={selectedValue === IMAGE_EDIT_WORK_MODE.LAYERS}
            icon={<Layers sx={{ fontSize: 18 }} />}
            title={t(MODAL_IMAGE_EDIT_LAYERS_TITLE)}
            onClick={() => onChange(IMAGE_EDIT_WORK_MODE.LAYERS)}
          />
        </Box>
      </Box>
      <Divider sx={{ borderColor: "#E0E0E0" }} />
    </Box>
  );
};

export default WorkModeSelector;
